import parseISO from "date-fns/parseISO";
import isAfter from "date-fns/isAfter";

import type { IBrazilianIssuerManagementReport } from "types/graphqlTypes";

interface ICurrentManagementReportAnchorProps
  extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
  lastQuarterlyManagementReport: Partial<IBrazilianIssuerManagementReport> | null;
  lastYearlyManagementReport: Partial<IBrazilianIssuerManagementReport> | null;
  reportSource?: IBrazilianIssuerManagementReport | null;
  children?: React.ReactNode;
}

export default function CurrentManagementReportAnchor({
  lastQuarterlyManagementReport,
  lastYearlyManagementReport,
  reportSource,
  children,
  ...props
}: ICurrentManagementReportAnchorProps) {
  if (reportSource) {
    if (reportSource.type === "ITR") {
      return (
        <a href={reportSource.pdfURL} target="_blank" rel="noopener noreferrer" {...props}>
          {children || "Link do Release"}
        </a>
      );
    }

    if (reportSource.type === "DFP") {
      return (
        <a href={reportSource.pdfURL} target="_blank" rel="noopener noreferrer" {...props}>
          {children || "Link do Release"}
        </a>
      );
    }
  }

  if (lastQuarterlyManagementReport && lastYearlyManagementReport) {
    const lastQuarterlyDateOfReference = parseISO(lastQuarterlyManagementReport.dateOfReference);
    const lastYearlyDateOfReference = parseISO(lastYearlyManagementReport.dateOfReference);
    if (isAfter(lastQuarterlyDateOfReference, lastYearlyDateOfReference)) {
      return (
        <a href={lastQuarterlyManagementReport.pdfURL} target="_blank" rel="noopener noreferrer" {...props}>
          {children || "Link do Release"}
        </a>
      );
    }
    return (
      <a href={lastYearlyManagementReport.pdfURL} target="_blank" rel="noopener noreferrer" {...props}>
        {children || "Link do Release"}
      </a>
    );
  }
  if (lastQuarterlyManagementReport && !lastYearlyManagementReport) {
    return (
      <a href={lastQuarterlyManagementReport.pdfURL} target="_blank" rel="noopener noreferrer" {...props}>
        {children || "Link do Release"}
      </a>
    );
  }
  if (!lastQuarterlyManagementReport && lastYearlyManagementReport) {
    return (
      <a href={lastYearlyManagementReport.pdfURL} target="_blank" rel="noopener noreferrer" {...props}>
        {children || "Link do Release"}
      </a>
    );
  }
  return null;
}
